(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXDetailController', CloudPBXDetailController);

    /* Added UIFormAccess
    CloudPBXDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CloudPBX'];

    function CloudPBXDetailController($scope, $rootScope, $stateParams, previousState, entity, CloudPBX) {
    */
    CloudPBXDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CloudPBX', 'UIFormAccess'];

    function CloudPBXDetailController($scope, $rootScope, $stateParams, previousState, entity, CloudPBX, UIFormAccess) {
        var vm = this;

        vm.cloudPBX = entity;
        vm.previousState = previousState.name;
        vm.UIFormAccess = UIFormAccess;

        var unsubscribe = $rootScope.$on('telestatApp:cloudPBXUpdate', function(event, result) {
            vm.cloudPBX = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
